import { render, staticRenderFns } from "./FormulationProductCatalogueTab.vue?vue&type=template&id=4fcfde80&scoped=true&"
import script from "./FormulationProductCatalogueTab.vue?vue&type=script&lang=js&"
export * from "./FormulationProductCatalogueTab.vue?vue&type=script&lang=js&"
import style0 from "./FormulationProductCatalogueTab.vue?vue&type=style&index=0&id=4fcfde80&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fcfde80",
  null
  
)

export default component.exports